import { SET_VAR_VALUE, SET_INVENTORY_CODE_ITEM, SET_LOCATION_CODE} from "../action/varValueActions";


const initialState = {
  data: {},   // store API response here
  inventoryCodeItem: {},  // Add this line
  locationCode: {},
};

export default function varValueReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VAR_VALUE:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };

  case SET_INVENTORY_CODE_ITEM:  // Define this in your actions file
     return {
        ...state,
        inventoryCodeItem: action.payload,  // Or { ...state.inventoryCodeItem, ...action.payload }
      };

  case SET_LOCATION_CODE:
    return {
      ...state,
      locationCode: action.payload,
    };
       default:
      return state;
  };
}
